import config from './config/dept'
import axios from '@/utils/request'
export const deptSelect = params => axios.post(config.deptSelect, params)
export const deptTree = params => axios.post(config.deptTree, params)
